// @module Question
define(
	'Question.Model'
,	[
		'SCModel'
	,	'underscore'
	,	'Utils'
	]
,	function (
		SCModelModule
	,	_
	,	Utils
	)
{

	var SCModel = SCModelModule.SCModel;
	function QuestionModel(model, options) {
		SCModel.call(this, model, options);
		this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(getExtensionAssetsPath('Modules/QAndA/SuiteScript2/Tavano.QAndA.Service.ss'),true)
		}
	}

	QuestionModel.prototype = Object.create(SCModel.prototype);
    QuestionModel.prototype.constructor = QuestionModel;
	return QuestionModel
});
